// extracted by mini-css-extract-plugin
export default {"user":"userMenu_user__7MbqU","user__image":"userMenu_user__image__I-tIg"};